export default {
  header: "My Home Page",
  view: "Home",
  weather: {}
};
